import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { InfoIcon } from '../InfoIcon';
import { Typography } from '../Typography';
import styles from './Badge.module.scss';
import { skinToTypographyMap, sizeToTypographyVariantMap } from './Badge.utils';
export const Badge = /*#__PURE__*/ React.forwardRef(function Badge(props, ref) {
    const { children, skin = 'default', size = 'default', rounded = false, outlined = false, info, className, as, testId } = props, rest = _object_without_properties(props, [
        "children",
        "skin",
        "size",
        "rounded",
        "outlined",
        "info",
        "className",
        "as",
        "testId"
    ]);
    const hasInfo = Boolean(info);
    return /*#__PURE__*/ _jsxs(Typography, _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        testId: testId,
        className: cn(styles.root, className, styles[skin], styles[size], {
            [styles.outlined]: outlined,
            [styles.rounded]: rounded,
            [styles.withInfo]: hasInfo
        }),
        as: as,
        variant: sizeToTypographyVariantMap[size],
        skin: skinToTypographyMap[skin],
        children: [
            children,
            hasInfo && /*#__PURE__*/ _jsx(InfoIcon, {
                info: info,
                hideOnMobile: true,
                size: "s",
                className: styles.infoIcon,
                testId: testId ? "".concat(testId, "-info") : undefined
            })
        ]
    }));
});
